import React, { Component } from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import Counter from '../BodyItems/Counter';
import WOWlogo from './../../img/WOWlogo.png';

class LayoutAdvert extends Component {
    render() {
        return (
            <Container style={{ textAlign: "center" }}>
                <img src={WOWlogo}/>
                {/*
                <Counter />
                */}
            </Container>
        )
    }
}

export default LayoutAdvert;
